export default {
  months: {
    jan: '一月',
    feb: '二月',
    mar: '三月',
    apr: '四月',
    may: '在五月',
    jun: '六月',
    jul: '在七月',
    aug: '八月',
    sep: '九月',
    oct: '十月',
    nov: '十一月',
    dec: '十二月',
  },
  all: '全部',
  day: '当日',
  one_month: '一个月',
  three_months: '三个月',
  six_months: '六个月',
  one_year: '一年',
  increase: '增加',
  deduction: '减少',
  memo: '留言',
  enter_memo: '请输入留言',
  price: '金额',
  new: '最新',
  past: '过去',
  enrollment: '登录',
  re_enter: '重新输入',
  registration_complete_txt: '登录完成',
  registration_failed_txt: '登录失败',
  bank_name: '银行名',
  locale_name: '中文(中国)',
  sale_registration: '出售登记',
  apply: '申请',
  status: '状态',
  wallet: '钱包',
  buy: '购买',
  sell: '出售',
  breakdown: '记录',
  act_buy: '购买',
  act_sell: '出售',
  asset: '资产',
  select: '选择',
  no_select: '别无选择',
  account: '帐户',
  balance: '平衡',
  login: '登录',
  logout: '退出',
  register: '注册',
  select_cancel: '取消选中',
  cancel: '取消',
  modify: '编辑',
  auto_input: '(自动输入)',
  confirm: '确认',
  look_up: '查询',
  password: '密码',
  account_delete: '注销',
  detail: '详细信息',
  list_detail: '详细信息',
  birth: '生日',
  welcome: '欢迎',
  please_login: '请登录',
  confirmation_login: '您可以在登录时进行检查。',
  id: 'ID',
  find_id: '查找ID',
  find_password: '查找密码',
  back: '返回',
  agreement: '协议',
  info_input: '输入信息',
  success: '完成',
  agree_msg: '我同意',
  all_agree: '我同意所有',
  agree: '同意',
  confirm_password: '确认密码',
  repeat_password: '确认密码',
  next: '下一个',
  before: '回去',
  register_success: '您已注册',
  verify: '确认',
  retention: '持有',
  allow: '(允许)',
  disallow: '(不允许)',
  upload_btn: '请在此处删除或单击文件。',
  continue_entry: '请在下面输入“ [+:verification]”以继续',
  login_msg_1: '请在ONEWORLDPAY<br>上使用COIN相关的账号！',
  login_msg_2: '请通过我们ONEWORLDPAY交易并使用钱包和服务',
  login_msg_3: 'ONEWORLDPAY支持所有环境',
  cocofx_register: '注册ONEWORLDPAY',
  register_msg_1: '加入作为会员xxxxx。 <br />请同意我们的条款和条件',
  register_msg_3: '一个ONEWORLDPAY帐户会给安心为大家服务的访问。',
  register_msg_all:
    '所有人同意包括对必填项和可选项的同意，您可以单独选择同意。即使您拒绝同意这些选项，也可以使用该服务。',
  register_title: '我是19岁以上的年龄以上。',
  register_title_2: 'ONEWORLDPAY条款',
  register_title_3: 'ONEWORLDPAY集成服务条款',
  register_title_4: 'ONEWORLDPAY营销杠杆同意',
  register_title_5: '同意收集和使用个人信息',
  register_title_6: '同意收集和使用位置信息',
  register_title_7: '同意收集其他个人资料信息',
  register_title_8: '输入ONEWORLDPAY帐户信息',
  register_title_9: '输入信息',
  register_msg_4:
    '这些条款适用于公司提供的所有服务等。<brxxx />接受这些条款，您可以使用这些服务而无需签订单独的合同',
  required: '[需要]',
  option: '[可选择的]',
  otp_notice: '状态被激活和停用OTP不可能的。',
  required_check: '请检查所有必填字段',
  check_input: '请输入所有的细节。',
  register_guide: '如何使用ONEWORLDPAY',
  register_step1: 'COCO点击付款按钮',
  register_step2: '登录COCO收费',
  register_step3: '支付/充值COCO BANK登录',
  copy: '复制',
  no_account: '没有注册的帐户。',
  inviter_link: '推荐人链接',
  register_used_account: '注册经常使用的账户',
  security_certification: '安全认证',
  company: '企业',
  exact_calculation: '调整',
  profile: '会员资料',
  inquiry: '查询',
  inquiry_history: '联系方式',
  announcement: '通知',
  information: '信息',
  history: '历史',
  registration_date: '登录日',
  pay: '付款',
  detail_search: '详细搜索',
  market: '市场',
  holding: '保持',
  fee_charged: '手续费附加额',
  type_of_charge: '手续费附加类型',
  auto: '自动的',
  manual: '手动的',
  s_usdt_protocol: '选择泰德协议',
  header: {
    c2c_enroll: '购买/出售 登录',
    wallet_list: '钱包/记录查询',
    wallet: '钱包',
    c2c_list: '购买/出售记录',
    no_c2c_sell_list: '没有销售记录。',
    transfer_list: '兑换记录',
    no_transfer_list: '没有兑换记录',
    withdrawal_list: '存/取款记录',
    my_info: '我的信息',
    home: '主要',
    payment_history: '帐单纪录',
    account_transfer: '转账',
    transfer_history: '转账记录',
    register_used_account: '注册经常使用的账户',
    exchange: '为了交换',
    exchange_store: '交易所',
    exchange_list: '汇率查询',
    email: '电子邮件',
    email_list: '电子邮件历史记录',
    otp: 'OTP',
    otp_list: 'OTP历史',
    register_account: '注册帐号',
    calculation_account_list: '结算清单',
    security_certification: '安全认证',
    exact_calculation: '调整',
    history: '历史',
    coco_open_market: 'COCO公开市场',
    information: '信息',
    my_profile: '我的信息',
    email_modify: '编辑电子邮件',
    password_modify: '修改密码',
    inquiry: '查询',
    one_on_one_inquiry: '1:1 查询',
    frequently_asked_questions: '常问问题',
    announcement: '通知',
    notice: '公告',
    server_notice: '服务器公告',
    service_center: '服务中心',
    profile: '会员资料',
    company: '企业',
    account_management: '账户管理',
    do_exchange: '兑换',
    transfer: '转让',
    look_up: '参考',
    faq: '常问问题',
    server: '服务器',
    email_request: '电子邮件联系',
    Balance_transfer_history: '市场余额移动记录',
    no_balance_transfer_history: '没有市场平衡运动的历史。',
    manual: '手册',
  },
  header_sub: {
    exchange_list: '兑换记录',
    transfer_list: '转账记录',
  },
  footer: {
    footer_msg: '请在ONEWORLDPAY上使用COIN相关的账号！',
    footer_sub_msg: '请通过我们的ONEWORLDPAY使用交易，钱包和服务',
    footer_sub_msg2: '提示',
    footer_sub_msg3: 'ONEWORLDPAY支持所有环境',
    ICO: 'ICO',
    c2c: 'C2C交易所',
    b2c: 'B2C交易所',
    margin_exchange: '保证金交易所',
    futures_exchange: '期货交易所',
    Binary: '二元期权',
    open_marcket: '公开市场',
    game: '游戏',
    proceed: '正在进行的交易',
    public: '已列出',
    direct_ex: '直接兑换',
    buy: '购买',
    sell: '出售',
    buy_sell: '买/卖',
    holding_coin: '持有硬币',
    fee: '费用信息',
    exchange: '交流',
    transfer_record: '交易记录',
    Leverage: '杠杆',
    live_exchange: '实时交易',
    demo_exchange: '模拟交易',
    contest: '竞赛',
    powerball: '强力球',
    law:
      '法律：ONEWORLDPAY.COM 登录号码：70638826927（U 6 29 Railway Pde EastwoodNSW 2122）',
    law1:
      'Trading Point of Financial Instruments Ltd（澳大利亚）的全部所有者ONEWORLDPAY PTY Ltd登录号码：70638826927商号。',
    law2:
      '该网站由ONEWORLDPAY Corp运营。ONEWORLDPAY Corp的批准号码为64190-由Auxiliary finance service制约，参考号码为70638826927在澳大利亚登录。',
    law3: 'ONEWORLDPAY是根据澳大利亚金融商品投资方针运营的。',
    law4:
      'ref. no. 538324 | ABN reg. 70638826927 | BA reg. 64190. 在居住国家的法律规定中，确认ONEWORLDPAY服务是否允许使用是顾客的责任。',
    law5: '请阅读ONEWORLDPAY的危险公示专文。',
    law6:
      'ONEWORLDPAY不为美国、伯利兹、毛里求斯、日本、阿尔伯塔、英属哥伦比亚、魁北克、萨斯喀彻、海地、苏里南、北韩、波多黎各和塞浦路斯占领地区的居民提供服务。',
    law7: '详细内容请参考常问问题制约部分。请参考我们的风险公示',
    law8:
      '限制地区：Trading Point of Financial Instruments Ltd不向第三世界国家地区提供投资和附加服务。',
    law_warn: '风险提示: ',
    law_1:
      'CFD具有高风险和复杂的产品，由于杠杆作用会有很大的风险。个人投资者69.10％中CFD交易时，都会亏钱。',
    law_2:
      '您必须考虑是否能接受和理解CFD的运行方式，拥有较高赔钱的风险。请参考我们的风险公示。',
    alert_title: '注注和',
    coco_market: 'COCO市场',
    ieo_market: 'IEO市场',
    news: '新闻',
    event: '活动',
    platform_rental_title: '平台出租',
    education: '教育',
    online_Academy: '线上学院',
    offline_Academy: '线下学院',
    shopping_basket: '购物车',
    best_product: 'best 商品',
    order: '订购',
    my_page_title: '我的页面',
    member_info_management: '会员信息管理',
    order_management: '订单管理',
    my_question: '我的问题',
    one_enquiry: '1：1咨询',
    community: '社区',
    lotto: '乐透型彩票',
    rock_event: '剪刀石头布',
    quiz_game: '答题游戏',
    ladder_game: '梯子游戏',
    tetris: '俄罗斯方块',
    split_lotto: '分享彩票',
    day_Lottery: '一日彩票',
    attendance: '签到',
    scoop_out: '转发',
    forum: '论坛',
  },
  b2c_exchange: {
    trading_view: 'TradingView',
    basic_chart: '基本图表',
    today_hight: '高价（同一天）',
    today_row: '低价（同一天）',
    tightening_strength: '紧固强度',
    h24_volume: '交易量（24H）',
    h24_transaction_amount: '交易金额（24H）',
    previous_days_closing_price: '前一天的收盘价',
    auxiliary_indicator: '辅助指标',
    unlimited_number: '您可以选择不限数量的指标。 ',
    rod_type: '杆型',
    chart_type: '图表类型',
    market_name: '市场名',
    present_price: '现价',
    compared_to_the_previous_day: '前日对比',
    volume: '交易量',
    coin_name_and_symbol_search: '币名/搜索',
    event: '种类',
    asking_price_window: '叫价窗',
    sell_order: '卖出',
    buying_order: '买入',
    limits: '指定价',
    maximum_order_price_quantity: '最大订购价格数量',
    direct_input: '直接输入',
    order_classification: '订单分类',
    order_available: '可订购',
    order_quantity: '订单数量',
    total_order_amount: '订单总额',
    quantity_user_fee_rate: '数量使用者手续费率',
    quantity_creator_fee_rate: '数量组织者手续费率',
    reset: '重启',
    conclusion_price: '成交量',
    tightening_amount: '成交量',
    execution_time: '成交时间',
    execution_price: '成交价格',
    execution_quantity: '成交数量',
    execution_amount: '成交金额',
    order_date_and_time: '订单日期和时间',
    transaction_coin: '交易币',
    order_price: '订单价格',
    untraded_quantity: '未成交数量',
    state: '州',
    current_price: '现价',
    division: '区分',
    transaction_price: '成交价',
    week52_high: '52周新高',
    week52_minimum: '52周最低',
    days_closing_price: '前一天的收盘价',
    same_day_high_price: '当日最高价',
    low_price_on_the_day: '当日最低价',
    average_price: '平均价格',
    cumulative_quantity: '累计量',
    cumulative_amount: '累计量',
    selection: '选拔',
    minimum_ask_quantity: '最高要价',
    save: '救',
    accounts_that_can_be_traded: '没有可用的交易账户。',
    won_pay: '韓元',
    coin_order: '订购',
    asking_price: '询问价格',
    chart: '图表',
    quote: '引用',
    order_details: '订单详细信息',
    account_number: '帐号',
    moving_quantity: '移动数量',
    registration_date: '登记日期',
  },
  main_msg: {
    about_1_title: '世界上最好的加密货币交易服务',
    about_1_msg: 'ONEWORLDPAY引领有关COIN的所有服务',
    about_1_1_msg: '世界首家最齐全的买卖加密货币市场',
    about_1_2_msg: '可以在ONEWORLDPAY体用直接兑换',
    about_2_title: '立即兑换系统',
    about_2_msg:
      'ONEWORLDPAY使用稳定的多重并行匹配技术 先进的设计技术可实现即时交换 我有货币兑换系统',
    about_3_title: '创建钱包',
    about_3_msg:
      'ONEWORLDPAY由国内最强的技术团队组成，安全专家具备最尖端的安全系统，提供Wallet系统。',
    about_4_title: '简易交易系统 （C2C）',
    about_4_msg:
      'ONEWORLDPAY建立了用户更人性化的便捷交易系统，使交易更加方便。',
    c2c_main_msg1_1: 'ONEWORLDPAY拥有一个稳定的多重平行匹配技术，',
    c2c_main_msg1_2: '可以立即兑换的高度化设计技术的兑换系统。',
    c2c_main_msg1_3: '',
    c2c_main_msg2_1: '安全专家已经ONEWORLDPAY是由韩国最好的工程师',
    c2c_main_msg2_2: '配备了国家的最先进的安全系统提供电子钱包系统。',
    c2c_main_msg3_1: 'ONEWORLDPAY更容易建立人性化的交易系统',
    c2c_main_msg3_2: '它可以很容易地交易。',
  },
  toasted_msg: {
    confirm: '已确认',
    changed: '更改',
    withdrawal: '已停用',
    register: '已登录',
    delete: '它已被删除。',
    title: '通知',
    exchange: '直接货币已成功处理。',
    search: '已查看',
    deposit_request: '您的存款请求',
    withdraw_request: '要求提款',
    create_account: '已创建',
    modify: '修改',
    cancel: '取消',
    trade_confirm: '交易已确认。',
    trade_reject: '交易被拒绝。',
    copy: '已复制',
    nice_msg: '如果您的浏览器设置不允许弹出窗口，则身份验证将无法正常进行。',
    nice_title: '指南',
    nice_success: '您的认证成功。',
    nice_error: '我无法验证自己的身份。',
    no_transfer: '没有交换信息',
    email_auth: '电子邮件验证成功完成',
    email_auth_send: '验证电子邮件已发送',
    kyc_withdraw: '帐户验证成功',
    not_allow_trade: '交易无效',
    id_find_mail_send: '您的电子邮件已发送。',
    duplicate_check: '重复的ID或邮件。',
    pay: '付款完毕。',
    msg_holding: '保持',
    msg_read_care: '您确认注意事项了吗？',
    answer_care: '是，我已确认',
    continuation: '继续',
    continue_entry: '如果要继续的话，请在下面输入“[+:verification]”。',
  },
  private: {
    market_name: '市场名',
    deal_list: '出售记录',
    app_list: '购买记录',
    app_detail: '详细购买记录',
    deal_buy_asset: '要购买的资产',
    buy_price: '购买价格',
    confirmed_source_amount: '确定出售数量',
    holding_source_amount: '未确定出售数量',
    potential_source_amount: '数量',
    direct_market: '直接兑换',
    deal_enroll: '出售登记',
    app_enroll: '购买登记',
    select_market: '请选择市场',
    fee_rate: '手续费',
    free: '免费',
    deal_info_input: '请输入出售信息',
    deal_source_amount: '出售数量',
    deal_price: '单价',
    deal_enroll_account: '出售登记用账号',
    account_select: '选择帐户',
    direct_asset_select: '请选择要出售和购买的资产',
    please_select_asset: '请选择资产',
    basic_rate: '当前价格',
    direct_transfer_buy: '立即购买',
    direct_transfer_sell: '立即出售',
    direct_source_amount: '交换数量',
    direct_target_amount: '应用数量',
    direct_asset_buy: '用{0}进行购买',
    direct_asset_sell: '作为{0}出售',
    selected_deal_info: '所选择的出售信息',
    deal_source_asset_title: '购买资产',
    deal_total_source_amount: '总出售量',
    app_info_input: '输入购买信息',
    app_amount: '购买数量',
    app_deal_price: '单价',
    pay_target_amount: '付款数量',
    fee: '手续费',
    fee_calc: '手续费金额',
    msg_fee_calc: '减少{0}左右。',
    app_account: '购买登记用账户',
    app_receive_account: '选择要接收的帐户',
    c2c_buy_select_asset: '请在主页上选择要购买的出售公示',
    go_home: '回到主页',
    buy_calc_spread: '购买汇率',
    sell_calc_spread: '卖出价',
    cs_market_asset: '资产对',
    cs_market_basic_rate: '基线销售率',
    transfer_type: '货币类型',
    exchange_rate: '适用汇率',
    submit_transfer: '立即交换',
    deal_source_min_amount: '最少购买数量',
    closed_date: '终结日',
    no_deal: '无销售清单',
    app_price_per_quantity: '单价',
    app_fee_amount: '手续费 合计',
    select_deal_app_list: '所选择的购买记录',
    no_select_deal_app_list: '此交易没有购买记录',
    transfer_source_amount: '基准资产数量',
    transfer_target_amount: '相对资产数量',
    transfer_basic_rate: '应用买卖基准率',
    transfer_spread_rate: '应用点差率',
    transfer_exchange_rate: '应用汇率',
    transfer_list_detail: '详细兑换申请记录',
    transfer_source_asset: '基准资产',
    transfer_target_asset: '相对资产',
    transfer_source_account_number: '基准资产账号',
    transfer_target_account_number: '相对资产帐号',
    transfer_detail_type: '交换类型',
    transfer_regdate: '申请日期',
    transfer_asset_info: '{0}至{1} {2}',
    transfer_asset_select: '请选择要替换的资产。',
    msg_transfer_buy: '用{0}进行购买',
    msg_transfer_sell: '以{0}出售',
    deal_fee_amount: '卖出公示者 附加手续费',
  },
  wallet_page: {
    total_amount: '总支出额',
    have_asset: '持有资产',
    asset_list: '资产列表',
    account_list: '帐户列表',
    account_create: '创建账户',
    deposit: '存款',
    withdraw: '取款',
    deposit_list_look: '存款记录查询',
    deposit_look: '存款查询',
    withdraw_list_look: '取款记录查询',
    withdraw_look: '提款查询',
    account_modify: '编辑帐户',
    deposit_apply: '申请存款',
    withdraw_apply: '取款',
    deposit_request_amount: '存款金额',
    withdraw_request_amount: '取款金额',
    withdraw_account_info: '提款帐户信息',
    holder_name: '持有人的姓名',
    bank_name: '银行名称',
    withdraw_bank_address: '帐号',
    withdraw_address: '资产地址',
    qr_address: '帐户地址',
    create_qr_address: '开设帐户地址',
    account_enroll: '帐户注册',
    account_seq: '账户专号',
    account_title: '帐户名',
    account_msg: '请输入要变更的账户名',
    regdate: '开户日期',
    before_regdate: '(开户前)',
    holding_balance: '冻结金额',
    select_asset: '选择资产',
    create: '创建',
    deposit_list: '存款记录',
    no_deposit_list: '没有存款申请的详细信息。',
    deposit_apply_detail: '详细存款申请记录',
    asset_title: '资产名称',
    request_amount: '请求金额',
    withdraw_list: '取款记录',
    no_withdraw_list: '没有取款申请记录',
    withdraw_apply_detail: '详细取款申请记录',
    withdraw_fee_total_amount: '总取款额（包含手续费）',
    net_amount: '最终金额',
    fee_type: '手续费类型',
    create_account_address: '开户地址',
    deposit_msg: '从钱包外面存入我的钱包{0} {0}。',
    deposit_msg_1: '一旦被批准350倍（确认）的嵌段链{0}的交易将反映在钱包。',
    deposit_step_1: '步骤1首先检查ID {0}备忘录。',
    deposit_step_1_1: '我的笔记ID {0}',
    deposit_step_1_2:
      '{0}当你的存款必须标记你自己的笔记ID。 {0}，没有转印笔记ID丢失。',
    deposit_step_1_3: '查看您的{0}钱包地址。',
    deposit_step_1_btn: '注身份证复印',
    deposit_step_2: '第2步：检查你的钱包地址。',
    deposit_step_2_1: 'QR码',
    deposit_step_2_2: '钱包地址',
    deposit_step_2_3:
      '最低存款量的<span style = “颜色：＃4a90e2”> {0} {1} </跨度>。',
    deposit_step_2_btn: '钱包复制地址',
    deposit_msg_2: '请检查',
    deposit_msg_2_1: '这个地址都是只存。',
    deposit_msg_2_2:
      '它需要以符合完成的总时间可通过块链网络的拥塞的影响，cryptocurrency星块链接拥塞的<span style ="color: #4a90e2; cursor: pointer;">此处</span>你可以检查。',
    no_account_list: '没有帐户列表。',
    no_favorite_account_list: '没有收藏夹帐户列表。',
    enter_wallet_adress: '输入钱包地址',
  },
  my_page: {
    my_profile: '我的信息',
    user_name: '用户名',
    email_address: '电子邮件',
    register_regdate: '注册日期',
    last_login: '上次登录',
    auth_complete: '身份验证完成',
    not_auth: '未认证',
    expdate: '到期日',
    act_auth: '认证',
    realname_auth: '人员身份验证',
    email_auth: '电子邮件认证',
    otp_auth: 'OTP 认证',
    enroll: '登录',
    security: '安全级别',
    show_security: '查看安全等级',
    auth_withdraw_address: '取款地址验证',
    apply_list: '申请记录',
    password_modify: '修改密码',
    email_modify: '修改电子邮件',
    account_block: '注销',
    placeholder_old_password: '请输入您的现有密码',
    placeholder_new_password: '请输入新密码',
    placeholder_confirm: '请再输入一次',
    placeholder_password: '请输入密码',
    placeholder_email: '请输入新的电子邮件',
    mail_cert_list: '电子邮件应用历史',
    no_mail_list: '没有电子邮件应用历史。',
  },
  kyc: {
    str_birth: '出生年月日',
    enter_adress: '请输入资产地址',
    register_account: '注册帐号',
    kyc_enroll: '申请KYC认证',
    auth: '身份验证',
    auth_code_send: '发送验证码',
    auth_code: '验证码',
    msg_auth_code: '请在5分钟内输入您的验证码',
    type_title: '类型名称',
    withdraw_auth: '取款地址验证',
    select_asset: '选择资产',
    select_bank: '选择银行',
    holder_name: '储户名',
    birth: '出生的6位数字',
    address: '资产地址',
    withdraw_list: '取款账户申请记录',
    bank_name: '银行',
    withdraw_info: '取款账户信息',
    withdraw_complete: '资产已被验证。',
    regdate: '登录日期',
    delete_withdraw_address: '取款地址变更',
    delete_success_address: '撤出地址已更改。',
    kyc_cert_list: 'KYC申请记录',
    no_kyc_list: 'KYC是没有应用历史。',
    no_kyc_withdraw_address_list: '没有支付账户的应用历史。',
  },
  otp: {
    enter_verification_number: '输入您的OTP验证码',
    otp_auth: 'OTP身份验证',
    authenticode: 'OTP密钥',
    otp_deactivate: '停用OTP',
    msg_authenticator_installation:
      '请在智能手机或台式机上安装“ Google Authenticator”应用',
    android: 'android ',
    or: '或 ',
    iphone_series: 'iPhone，iPad和iPod',
    windows_phone: ' Windows Phone',
    and: ', 和',
    msg_microsoft_other_systems: '“其他系统，包括Microsoft Windows桌面”',
    msg_key: '此密钥',
    msg_use_loss_change: ' 写在纸上当您丢失设备或需要更改OTP时使用。',
    msg_brcode_touch:
      '运行“ Google Authenticator”应用，然后点击屏幕底部的<b>扫描QR条形码</b>。',
    msg_input_authenticode:
      '请在下面的“授权代码”字段中输入显示在设备屏幕上的验证码。',
    otp_key: 'OTP密钥',
    otp_activate: 'OTP激活',
    otp_copy: '已复制OTP密钥',
    otp_safe_keeping: '您是否将OTP密钥写在纸上并将其存储在安全的地方？',
    yes: '是',
    otp_register: '注册',
    otp_register_success: 'OTP注册成功完成',
    otp_delete_success: 'OTP擦除注册成功完成。',
    msg_click_key_copy: '单击以复制密钥',
    otp_login: 'OTP登录',
  },
  security: {
    show_security: '显示安全级别',
    grade: '等级',
    condition: '条件',
    restriction: '限制',
    no_grade: '未分级',
    no: '无',
    security_title: '受安全条件的约束',
    banner1: '可靠的安全性',
    banner2:
      '对于通过ONEWORLDPAY购买或出售，ONEWORLDPAY必须通过安全的结算和付款方案对接收ONEWORLDPAY安全数据加密，实时交易监控，买方和卖方保护政策，以及所有的付款。',
    banner_invite: 'ONEWORLDPAY还没有账号？',
    banner_join: '免费会员注册',
    banner3: '如何ONEWORLDPAY是保持我们的客户的安全',
    content1_h3: '买家保护',
    content1_text:
      '如果买方ohbaesong磨损或损坏mibaesong，ONEWORLDPAY可以弥补总付款金额，包括运费为符合条件的交易成本。*',
    content2_h3: '卖家保护',
    content2_text:
      '如果你收到一个未经授权的付款或mibaesong要求对卖方在销售符合条件，就可以得到全额保护。*',
    content3_h3: '数据加密',
    content3_text:
      '以帮助TLS，HTTPS连接保持支付，关键钉扎移动应用的，符合PCI标准更安全。',
    content3_btn: 'PCI法规遵从',
    content4_h3: '防欺诈',
    content4_text:
      '所有的交易都是通过分析您的帐户和支持，以防止欺诈行为和结算实时监控。',
    sec_h2: '检查购买',
    sec_text:
      'ONEWORLDPAY因为监控每天24小时，一年365天，当它检测到来自平常不同的东西联系买家交易要求您确认您的登录或购买。此外ONEWORLDPAY检查通过e-mail所有的采购和销售。',
    wran_h2: '如果你发现一个可疑点',
    warn_step1: '报告。',
    warn_step1_text1: '确认之后的细节还没有找到一个交易批准',
    warn_step1_text2: '报告问题>未经授权的活动报告',
    warn_step1_text3: '点击或立即联系ONEWORLDPAY。',
    warn_step2: '检查是否有其他问题。',
    warn_step2_text1:
      '查看近期交易活动和帐户设置，以确保该额外费用或变更，也请将此信息报告。',
    warn_step3: '请更改您的密码。',
    warn_step3_text1:
      '你可以在安全菜单上的帐户设置。或者，如果您无法在您的帐户登录',
    warn_step3_text2: '登录>登录问题',
    warn_step3_text3: '点击获取复位。',
    warn_btn: '报告未经授权的交易',
    online_h2: 'ONEWORLDPAY支持安全的网上活动。',
    online_h3: '帐户安全',
    online_text: '具有高度安全的密码保护您的帐户。',
    online_btn: '了解更多',
  },
  input: {
    id: '输入ID',
    password: '输入密码（8-32位数字与特殊字符）',
    repeat_password: '确认密码',
    user_name: '输入用户名',
    email_address: '输入E-mail地址',
  },
  oauth: {
    contact_msg: '想要访问应用程序中的{0}的以下信息。',
    agree_msg: '{0}你是否同意访问{1}的个人信息？',
    agree_info:
      '/储存一段服务的用户标识提供将被使用的信息，统计，帐户链接的CS等。基本信息并提供所需的项目是必须提供使用ONEWORLDPAY服务的信息。',
    agree_request: '供品',
    agree_msg2:
      '一旦同意，这些信息将按照条款和条件以及服务的隐私政策进行管理。',
    agree: '同意',
  },
  pay_head_foot: {
    account_management: '账户管理',
    settlement_account_list: '结算账户清单',
    account_summary_views: '帐户摘要视图',
    fund: '资金',
    history: '帐单纪录',
    help: '帮助',
    qa: '咨询',
    fee: '佣金',
    secure: '安全',
    go_shop: '购物',
    my_info: '我的个人资料',
    my_page: '帐户设置',
    out: '退出',
    in: '注册',
    about: '公司介绍',
    blog: '博客',
    employ: '乔布斯',
    site_map: '网站地图',
    developer: '开发人员',
    partner: '伙伴',
    privacy_state: '隐私政策',
    usage: '使用条款',
    feed_back: '反馈',
    warn_to_consumer:
      '通知客户：支付ONEWORLDPAYⓒONEWORLDPAY All rights reserved的预付费方式的业主不需要澳大利亚金融监管局的批准。请仔细阅读条款和条件。',
  },
  continue: '延续',
  pay_home: {
    cocobank_title: 'COCO银行',
    platform: '平台',
    platform_rental: '租赁平台',
    cocopay_is: 'ONEWORLDPAY是业务的增长',
    help: '帮助。',
    home_banner_1: '扩大潜在客户群遍及世界各地，并促进支付管理，',
    home_banner_2: '经营的卖家保护*，并允许安全与全天候防欺诈监控到店。',
    home_banner_3: '你可以更容易获得成功。',
    home_banner_warn: '*条款和条件适用于保护卖家。请参阅您的合同上的资格详情。',
    home_banner_join: '现在加入免费。',
    home_sec1_openShop: '您可以在ONEWORLDPAY开一家店。',
    home_sec1_btn: '为了应对',
    home_sec2_h2: '获取所需的付款方式。',
    home_sec2_text1: 'ONEWORLDPAY还可以接收在线付款，手机，甚至是电子邮件。',
    home_sec2_text2:
      '无论ONEWORLDPAY出售任何地方谁可以更方便，更安全的支付协助。',
    home_sec2_online_pay: '在线支付',
    home_sec2_online_text:
      '便于组可用ONEWORLDPAY付款按钮接受现金支付和定期支付，捐赠等时非常方便随着ONEWORLDPAY结帐，客户可以进行支付更加方便快捷。',
    home_sec2_online_more: '查看更多有关网上支付',
    home_sec2_voice_invoice: '电子邮件发票',
    home_sec2_voice_text:
      '对于支付给专业的免费发票简易电子邮件请求。海外客户以及可供谁不ONEWORLDPAY帐户的客户。',
    home_sec2_voice_more: '查看更多有关电子邮件发票',
    home_sec2_exchange_pay: '在交易所付款',
    home_sec2_exchange_text:
      '借助交易所上集成的钱包服务，您可以在合作伙伴公司的任何交易所进行充值和买卖硬币。',
    home_sec2_exchange_more: '了解有关交易所收费的更多信息',
    home_sec2_mobile_pay: '获取移动支付',
    home_sec2_mobile_text:
      '解决方案是针对移动设备自动优化。获得世界里，甚至通过移动网站或Android和iOS应用更容易支付。',
    home_sec2_mobile_more: '查看更多关于移动支付',
    home_sec3_h2: '找到ONEWORLDPAY特约合作伙伴更多的工作。',
    home_sec3_global:
      'ONEWORLDPAY将与世界顶级自由职业者的网站连接更多的全球机会。',
    home_sec3_btn: '检查自由ONEWORLDPAY',
    home_sec4_h2: '这很容易上手。',
    home_sec4_banner1: '了解你需要从ONEWORLDPAY商业中心开始一切。',
    home_sec4_banner2: '加盟商的帐户，并确认您的电子邮件地址',
    home_sec4_banner3: '认证的银行账户',
    home_sec4_banner4: '选择一个支付解决方案',
    home_sec5_h2: '为什么世界上许多运营商做的信任ONEWORLDPAY。',
    home_sec5_sub_text:
      '因为它是一个很好的选择。 ONEWORLDPAY是否想与25个电话卖家至少两个亿人连接到客户在超过200个全球市场。',
    home_sec5_h3: '安全。',
    home_sec5_h3_sub1:
      '自动确定骗局，24小时监控交易和买卖双方的保护程序，以保护您的业务和客户。',
    home_sec5_h3_more: '查看更多有关网上支付',
    home_sec5_h31: '全世界都在使用。',
    home_sec5_h31_sub1:
      '在世界各地，而无需输入信息每次付款迅速的时间。在26对货币市场的203，你可以通过信用卡，借记卡或支付ONEWORLDPAY。',
    home_sec5_h31_more: '查看更多有关电子邮件发票',
    home_sec5_h32: '快。',
    home_sec5_h32_sub1:
      '在大多数情况下，当客户支付会立即存入您的帐户ONEWORLDPAY。扣除银行或在任何地方ONEWORLDPAY付款可以支付给供应商或自由使用。',
    home_sec5_h32_more: '查看更多有关eBay网站上出售',
    home_sec6_h2: '简单的收费结构',
    home_sec6_sub:
      'ONEWORLDPAY会收取一定的费用，只有当销售取得。 ONEWORLDPAY费用是根据客户的位置和销售金额固定。',
    home_sec6_more: '查看更多有关费用',
    home_sec7_h2: '社区为韩国销售，CBT LAB',
    home_sec7_text1:
      '跨境贸易研究所（CBT LAB）是资助海外的电子商务ONEWORLDPAY韩国（ONEWORLDPAY韩国）商人社区启用。',
    home_sec7_text2:
      'CBT LAB帮助东海岸业务增长全球共享信息，如最新趋势，提示和最佳实践。',
    home_sec7_more: '了解如何采取CBT LAB的优势',
    home_sec8_h2: '满足合作伙伴联锁ONEWORLDPAY。',
    home_sec8_text1: '需要为您的网上业务的专业帮助？',
    home_sec8_text2:
      'Web托管解决方案，购物车，电子商务解决方案，如前期工程ONEWORLDPAY合伙买了这帮助您的业务。',
    home_sec8_text3: '现在发现ONEWORLDPAY为自己的公司的合作伙伴。',
    home_sec8_more: '更多的合作伙伴',
    home_sec9_h2: '成为全球畅销书。这将一起ONEWORLDPAY。',
    home_sec9_btn: '立即注册一个帐户',
    home_learn_h2: '了解更多',
    home_learn_li1: '网络支付解决方案',
    home_learn_li1_1: '网站付款标准',
    home_learn_li1_2: 'ONEWORLDPAY结帐',
    home_learn_li1_3: '在eBay上购买',
    home_learn_li1_4: '比较解决方案',
    home_learn_li2: '其他应付款',
    home_learn_li2_1: 'ONEWORLDPAY电子邮件发票',
    home_learn_li2_2: '移动商务',
    home_learn_li2_3: '业务的自动付款',
    home_learn_li2_4: 'ONEWORLDPAY对于B2B',
    home_learn_li2_5: 'ONEWORLDPAY自由职业者',
    home_learn_li3: 'ONEWORLDPAY设置和集成',
    home_learn_li3_1: 'ONEWORLDPAY商业中心',
    home_learn_li3_2: 'ONEWORLDPAY韩国商人社区（CBT LAB）',
    home_learn_li3_3: '添加ONEWORLDPAY ONEWORLDPAY到现场',
    home_learn_li3_4: '检查出最好的指南套装',
    home_learn_li3_5: '开发人员',
    home_learn_li3_6: '伙伴',
    home_learn_li3_7: '如何ONEWORLDPAY',
    home_learn_li4: '管理我的帐户',
    home_learn_li4_1: 'ONEWORLDPAY商业应用',
    home_learn_li4_2: '商务帐户设置',
    home_learn_li4_3: '卖家保护计划',
    home_learn_li4_4: '管理客户投诉',
    home_learn_li4_5: '了解退款（退款）',
    home_learn_li4_6: '了解帐户限制',
    home_learn_li4_7: '诈骗防范技巧',
    home_learn_li4_8: 'PCI法规遵从',
  },
  pay_nav: {
    view_your_account: '查看您的整个帐户',
    account_summary_views: '帐户摘要视图',
  },
  pay_login: {
    secure_sub_title: '登录和安全性',
    secure_my_profile: '我的个人资料',
    secure_update_complete: '环境状况和设置已经更新。',
    secrue_suggest: '每当你告诉我们你的经验。',
    search: '取回',
    my_info: '个人信息',
    update: '更新',
    e_mail: '电子邮件',
    default: '基本信息',
    call: '电话',
    phone: '（手机）',
    pay_mobile: '移动支付',
    trading: '给予和索取',
    password: '密码',
    change: '变化',
    secure_qa: '安全问题',
    staying: '记住我的登录更快采购',
    edit: '汇编',
    browse_manage: '管理所选设备和对保持登录状态的浏览器。',
    account_type: '账户类型',
    account_delete: '帐户取消',
    business: '业务',
    edit_email: '编辑电子邮件地址',
    change_email: '更改电子邮件地址',
    update_email: '添加您的电子邮件',
    eamil_url: 'E-mail地址',
    update_email_url: '添加您的电子邮件地址',
    error_email: '抱歉。默认的电子邮件不能被编辑。',
    confirm_new_email: '检查新的电子邮件地址',
    change_mail: '更改电子邮件',
    confirm: '确认',
    changing: '变化',
    deleting: '删除',
    reaming:
      '目前有两个与您的帐户关联的电子邮件地址。您可以添加更多5电子邮件。',
    qa_1: '什么是第一次参加学校的名字？',
    qa_2: '什么是第一只宠物的名字是什么？',
    edit_phone: '编辑现有的电话号码',
    korea: '韩国',
    explanation:
      '添加了数字，我确认您同意自动拨打，接听预录电话和文本取决于原因机关将两个数字相加的隐私政策进行说明。标准费率付费。',
    edit_phone_num: '变更电话号码',
    edit_password: '更改密码',
    confirm_password: '检查您当前密码',
    new_passod: '新密码',
    confirm_password_new: '确认新密码',
    secure_question: '安全问题',
    secure_pick: '选择题',
    secure_answer: '答案',
    edit_browse:
      '随着ONEWORLDPAY一键就可以快速完成支付，而不必每次都要登录时间英寸',
    already_log: '在登录到计算机上。',
    off_all: 'ONEWORLDPAY一键关闭所有设备上的',
    support: 'PayPal致力于让客户100％满意。如果您有您的帐户有问题',
    support_center: '客户支持',
    support_text1: '或检查',
    support_text2: '请参考。',
    support_warn:
      '如果您取消帐户，则无法取消您的帐户记录也将消失和可靠性水平。',
  },
  help: {
    support_center: '支持',
    resolution_center: '争议解决中心',
    qa_search: '搜索常见问题解答',
    common_qa: '普通问题',
    common_qa_1: '什么`为什么通过“获取链接基金更新您的订单状态后显示错误消息？',
    common_qa_2: '如何从韩国ONEWORLDPAY账户中提取资金？',
    common_qa_3: '如何添加借记卡或信用卡帐户ONEWORLDPAY？',
    common_qa_4: 'ONEWORLDPAY我忘记了帐户密码。如何重置密码？',
    common_qa_5: '我能取消已经发出已支付金额ONEWORLDPAY？',
    common_qa_6: '我如何收到通过ONEWORLDPAY付款？',
    common_qa_7: '如何发送通过ONEWORLDPAY支付？',
    common_qa_8: '如何添加一个银行账户ONEWORLDPAY帐户？',
    common_qa_9: '如何检查我的帐户ONEWORLDPAY相关联的银行帐户？',
    common_qa_10: '如何禁用帐户ONEWORLDPAY限制？',
    technical_support: '订阅技术问题和更新。',
    condition_cocopay: '查看ONEWORLDPAY状态',
    muliple_help: '更多方式获得帮助',
    trading_help: '为了解决这样的问题处理',
    tex_center: '税务中心',
    tex_help: '查找税务表格和其他资源',
    need_help: '联系我们',
    help_center: '联系客户支持',
    help_to_center: '联系客户支持',
    prepare: '即将推出。',
    fast_help: '请告诉我们您的问题，使我们能更快地帮助ONEWORLDPAY。',
    my_search: '搜索我的问题',
    common_problem: '常见问题',
    login_problem: '登录问题',
    unkown_charge: '未经授权的访问或未知的申请报告',
    send_money: '汇款',
    get_fund: '收到钱',
    withdraw_money: '取钱',
    pay_cancel: '付款或取消订单',
    pay_hold: '付款挂起或等待',
    refund: '退款',
    pre_pament: '预先核准付款',
    negative_balance: '负平衡',
    account_qa_1:
      '虽然它显示为“已完成”从我的帐户ONEWORLDPAY退出状态，这是为什么不包含银行账户的钱？',
    account_qa_2: '什么是我的提款ONEWORLDPAY的原因仍是“待定”状态？',
    account_qa_3: '为什么我撤回前？',
    item_title: '访问密码和帐户',
    item_title_2: '帐户资料＆设置',
  },
  business: {
    no_trade: '有没有可能交易市场。',
    view_your_account: '查看您的整个帐户',
    available: '可得到',
    calculate_late: '最近估计基于汇率金额。',
    payment_transfe: '支付转账',
    exchange: '货币交换',
    currency_update: '添加通话',
    update_btn: '加号按钮',
    currency_cal: '货币换算',
    pay_default: '首付款',
    payment_send: '发送或请求付款',
    account_list: '帐户列表',
    no_alias: '无别名',
    new_bank: '连接新银行',
    card: '卡',
    new_card: '连接新卡',
    credit: '信用',
    preference_payment: '选择您喜欢的在线支付方式。',
    payment_tip:
      '当网上购物或使用该手段商品和服务在付款。您可以在任何时候选择在结帐时不同的付款方式。',
    payment_more: '了解您的支付偏好',
    paymnet_changes: 'ONEWORLDPAY平衡',
    debit_card: '转账卡',
    currency_tip:
      '如果添加的货币，该货币以后接收的所有款项将记入相应的资金。基础货币被用来发送一个付款或付款请求。',
    currency_1: '澳大利亚元',
    currency_2: '瑞士法郎',
    currency_3: '捷克克朗',
    currency_4: '丹麦克朗',
    currency_5: '欧元',
    currency_6: '英镑',
    currency_7: '港元',
    currency_8: '福林',
    currency_9: '以色列新谢克尔',
    currency_10: '墨西哥比索',
    currency_11: '挪威挪威克朗',
    currency_12: '纽元兑美元',
    currency_13: '菲律宾比索',
    currency_14: '波兰兹罗提',
    currency_15: '俄罗斯卢布',
    currency_16: '瑞典克朗',
    currency_17: '新加坡元',
    currency_18: '铢',
    currency_19: '新台币',
    withdraw_account: '撤回账户',
    exchanged: '货币兑换后',
    exchange_rate: '汇率',
    exchange_tip: '汇率是基于当前汇率的估计量，交换费包含在ONEWORLDPAY。',
    currency_default: '（A）的日元被设置为默认货币。',
    currency_default_notice: '基础货币被用来发送一个付款或付款请求。',
    currency_default_notice2: '关闭通话的余额，不显示没有收到任何付款的电话。',
    currency_default2: 'JPY（S），默认',
    currency_quit_jp_btn: '关闭美元',
    currency_quit_btn: '千钧一发',
    bank_account: '帐号',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: '余额',
    bank_account_check: '保兑行',
    bank_account_remove: '删除银行',
    bank_continue: '你想继续吗？',
    bank_tip: '与银行待处理的交易被删除后进行处理。',
    bank_this_delete: '删除银行',
    card_tip: '该ONEWORLDPAY帐户要使用它无需花费或提款限额？',
    card_confirm: '检查卡。',
    card_type: '类型',
    expiry_date: '到期日',
    card_adress: '帐单地址',
    card_update: '卡更新',
    card_delete: '删除卡',
    card_this_delete: '删除卡',
    card_tip2:
      '此付款方法目前优选的。完成后，您可以设置不同的首选付款方式。处理是与（a）中未决的未定义删除后进行处理。',
    secure_code: '验证码',
  },
  shop: {
    shop_list: '商店列表',
    shop_create: '创建铺',
    shop_cre_date: '额外',
    shop_title: '商店名',
    shop_id: '商店ID',
    shop_state: '状态',
    shop_work: '工作',
    shop_detail: '更',
    shop_retouch: '水晶',
    shop_settlement: '结算清单',
    no_shop_history: '没有交易记录。',
    shop_history: '交易记录',
    no_shop_list: '没有店铺一览',
  },
  merchant: {
    create: '网店注册',
    update: '登录',
    retouch: '商店修改',
  },
  pay_legal: {
    service_usage: 'ONEWORLDPAY服务条款',
    detail_usage:
      '这些条款和条件将适用于亚太地区，拉丁美洲和欧洲的一些国家，中东和非洲用户。要查看条款和不同国家或地区的条件下，从下面的列表中进行选择。',
    nation: '选择一个国家',
    every_consumer: '所有用户',
    service_agree: '您的服务合同ONEWORLDPAY',
    privacy_state: '隐私政策',
    purpose_policy: 'ONEWORLDPAY使用政策',
    payment_agreement: 'ONEWORLDPAY其他方式付款协议',
    sell_buy: '商家和企业',
    shop_policy: 'ONEWORLDPAY支持存储策略',
    contract_profit: '合同以营利为目的的公司',
    billing_agreement: '结算协议',
    direct_debit_agreement: '收到ONEWORLDPAY资金和借记协议',
    additional_info: '更多信息',
    infringement: 'Somyeongseo违反政策',
    policy_update: '政策更新',
    warn1:
      '通知消费者：ONEWORLDPAY支付服务被看作是按照澳大利亚法律支付（储值工具）的预付费方式。',
    warn2:
      'ONEWORLDPAY支付的预付方式的业主ⓒCocofx私人有限公司不需要澳大利亚金融监管局的批准。我们也鼓励消费者（用户）仔细阅读这些条款和条件。',
    warn3: '本使用条款和通告的规定的条款和与特定ONEWORLDPAY服务相关的条件。',
  },
  pay_privacy: {
    effective_day: '生效日期：2019 3月28日',
    summary: '摘要',
    personal_data: '通过ONEWORLDPAY收集的个人数据',
    personal_date_cause: '理由保持您的个人资料ONEWORLDPAY',
    summary_1: '我们的用户',
    summary_2: '网站',
    summary_3: '或访问',
    summary_4: '服务',
    summary_5: '当使用用户',
    summary_6: '个人资料',
    summary_7:
      '如何收集和存储，管理和共享，解释传输已经编写了本隐私政策。访问我们的网站或使用该服务时，该隐私政策适用于您的个人资料，其他ONEWORLDPAY',
    summary_8: '用户',
    summary_9:
      '它并不适用于网站或不拥有在线web ONEWORLDPAY或调整，包括服务站点或服务。',
    summary2_1:
      'ONEWORLDPAY您可以访问我们的网站或当您使用以下类型的服务收集个人信息。',
    summary2_2: '使用向上和信息',
    summary2_3:
      '当您注册一个帐号使用ONEWORLDPAY的服务，以满足必要的信息，以提供用户所请求的服务来收集个人数据。',
    summary2_4:
      '根据所选择的服务，您可以要求提供创建用户名所需的标识信息，邮寄地址，电话号码，电子邮件地址，帐号。',
    summary2_5: '条款你可能会问，以提供额外的个人资料，这取决于服务。',
    summary3_1: '交易经验和信息',
    summary3_2:
      '使用ONEWORLDPAY，或者如果访问该网站，例如服务，从卖方购买，或收到钱，或者如果处理支付或汇款给朋友和家人，收集其他交易相关的信息，以及来自ONEWORLDPAY交易信息的。其他与贸易相关的信息，包括发送或请求金钱，物品或金钱支付服务的卖家，包括有关的所有信息来完成交易的信息和设备信息的支付方式，技术数据，位置信息等。',
    summary4_1: '参与者信息',
    summary4_2:
      '当您使用或访问网站ONEWORLDPAY服务收集的个人数据用户提供有关参与交易的其他参与者。',
    summary4_3: '要发送或请求的钱',
    summary4_4:
      '如果您发送或请求资金通过服务ONEWORLDPAY收集您的姓名，邮寄地址，电话号码，个人数据，如从参与者发送的钱给你的你的财务账户信息收钱。',
    summary4_5:
      '有关要求参与者的个人数据的范围可能取决于用于发送或要求金钱服务。',
    summary5_1: '付款方式为其他人而不是票据或票据要求付款给其他人',
    summary5_2:
      '如果使用ONEWORLDPAY服务，让他们付账代他人的，或者代表他们支付账单给其他用户，用户名，邮件地址，电话号码，电子邮件地址，用户计费，而不是账单或他人的帐户拥有者必须收集相关的个人资料，包括你想，而不是支付账号。',
    summary6_1: '钱添加到您的帐户',
    summary6_1_1: '您的帐户',
    summary6_2:
      '为了加钱到其他帐户的用户帐户或用户可以拥有，或者如果您使用ONEWORLDPAY服务请求被加入到量在此帐户对其他用户的另一边从用户有效地处理您的请求收集信息或可以从对方收集您的信息。',
    summary6_3:
      '例如，充电或使用服务ONEWORLDPAY请求，以添加到帐户的手机数量，你可以收集其他信息，包括个人资料，以及其他参与者的移动账户号码。',
    summary7_1: '与您的朋友和联系人人信息',
    summary7_2:
      '当用户在您的帐户连接的联系人列表，很容易给帮助人们处理当您的朋友和联系人ONEWORLDPAY。这样用户可以使用该设备，或者建立社会媒体平台或设备ONEWORLDPAY账户或社交媒体之间的连接时连接到该平台更好ONEWORLDPAY服务收集和ONEWORLDPAY使用您的联系人列表中的信息（姓名，地址，电子邮件地址等）改善环境。',
    summary8_1: '您选择的信息，以提供ONEWORLDPAY才能使用某些在线服务或额外服务',
    summary8_2:
      '如果请求或参加现场要求的功能或改进服务，或其他可选功能的选择，你可以收集有关ONEWORLDPAY用户的其他信息。',
    summary8_3:
      '如果从这些服务中用来收集信息的方法，由本隐私权政策声明不同，另行通知期间收集的信息。',
    summary9_1: '使用“ONEWORLDPAY不付款”的服务，当用户信息',
    summary9_2:
      '对于一些有限的服务，可能需要登录或使用您的帐户设置不付款。 ONEWORLDPAY将收集，所有的支付方式相关的设备信息，技术数据，位置信息需要用户完成交易的个人资料。当您选择帐户所有者和非贸易支付，你可以建立并与您的帐户关联收集交易信息。',
    summary9_3:
      '如果用户在不帐户拥有者，并选择非ONEWORLDPAY交易付款，收集和存储您提供的所有信息的使用和依照本隐私政策的信息共享。',
    summary10_1: '从第三方获得用户的具体信息',
    summary10_2:
      '从第三方（如商家），数据提供者，征信机构允许的范围内通过法律，你可以得到的信息。',
  },
  partner: {
    be_partner: '成为ONEWORLDPAY的合作伙伴。',
    banner_text:
      '购物平台提供商，市场，还有一个计费支持运营商需要支付服务提供商可以ONEWORLDPAY的合作伙伴。',
    banner_btn: '要联系您的客户经理',
    benefit: '合作伙伴有权ONEWORLDPAY好处',
    benefit_1: '整合与建设解决方案技术支持',
    benefit_2:
      '请随时联系我们的支持团队为您获得ONEWORLDPAY集成的帮助。 ONEWORLDPAY开发者门户还可以用来作为一种资源。',
    benefit_3: '通过营销机会的业务增长',
    benefit_4: '以提供ONEWORLDPAY可以吸引潜在客户的许多市场机会。',
    traction: '和牵引世界各地的付款。',
    traction1:
      'ONEWORLDPAY合作伙伴支持的创新平台，为顺利解决卖家的信任ONEWORLDPAY。',
    traction_btn: '更多的合作伙伴',
    program: 'ONEWORLDPAY合作伙伴计划是免费加入。',
    program_1: '请填写在线表格，我们将在ONEWORLDPAY与您联系。',
    program_2: '请介绍业务和运行的业务解决方案。',
    program_3: '请联系ONEWORLDPAY讨论必要的修改。',
    program_4: 'ONEWORLDPAY整合与和帮助确保他们收到付款ONEWORLDPAY。',
    program_btn: '要联系您的客户经理',
    common_qa: '常问问题',
    common_qa1: '是否有任何厂商ONEWORLDPAY合作伙伴？',
    common_qa1_text:
      'ONEWORLDPAY合作伙伴是B2B（企业对企业）公司，为客户提供解决方案ONEWORLDPAY。 ONEWORLDPAY正与组织，如购物车，网络托管公司，Web开发人员，物流提供商和数字营销公司，支付网关。',
    common_qa2: '什么ONEWORLDPAY合作伙伴资格？',
    common_qa2_text: '请联系您的客户经理',
    common_qa2_text_2: '您可以对合作伙伴的资格获得建议。',
    common_qa3: '我们提供的ONEWORLDPAY集成支持服务？',
    common_qa3_text:
      '一旦合作伙伴计划和ONEWORLDPAY批准加入注册，您可以访问有价值的集成文档和开发者论坛。它也可以让顾问证书集成支持。',
    common_qa4:
      '还有韩国的公司之外，我可以单独报名参加合作伙伴计划的每一个国家？',
    common_qa4_text:
      '这取决于您所在的国家经营业务。在ONEWORLDPAY正在部署专门的合作伙伴代表，在不同国家地区的要求。',
    common_qa4_more: '查看合作伙伴计划提供国家',
  },
  pay_main: {
    total_product: '总产品',
    total_sum: '骨料',
    pay_this_account: '设置此帐户作为付款方式。',
    bill_show: '此交易内容清单如下',
    banner_text: 'ONEWORLDPAY更安全',
    banner_text2: '快速付款。',
    banner_text3: '无论在哪里购物，将让您的金融信息安全。',
    footer_1: '条款和条件',
    footer_2: '用户协议',
    footer_3: '隐私政策',
    footer_4: '反馈',
    footer_5:
      '消费者的通知：Coco Bank个人资料预付款的所有者ⓒCocobank保留所有权利不需要批准瑞典金融监管机构。',
    footer_6: '使用条款',
    footer_7: '我们也鼓励您仔细阅读。',
    footer_8: '结算',
    wallet: '电子钱包管理',
    last_name: '性别',
    card_number: '卡号',
    three_number: '三位数字',
    name: '名',
    pay_cocopay: '通过ONEWORLDPAY支付',
    free_shipping: '如果ONEWORLDPAY帐户，你可以得到免费的退货运费，购买保护。',
    email_phone: '电子邮件或电话号码',
    login_error: '你有麻烦了签约？',
    pay_card: '付款卡',
    cancel_back: '取消并返回到前一页',
  },
  site_map: {
    site_map_tip: '一个链接，这将帮助你探索ONEWORLDPAY帐户。',
    map_fund: '资金',
    map_fund_1: '扣除',
    map_fund_2: '我使用的平衡能力是什么？',
    map_fund_3: '汇款或要求付款',
    map_fund_4: '呼叫管理',
    map_fund_5: 'ONEWORLDPAY我的借记卡折扣',
    map_fund_6: '获取ONEWORLDPAY借记卡',
    map_fund_7: 'ONEWORLDPAY信贷结算时间表',
    map_deal: '合同',
    map_deal_1: '查看所有优惠活动',
    map_deal_2: '活动的意见（包括资产和费用）',
    map_deal_3: '查看特价图形和图表',
    map_deal_4: '下载新政',
    map_deal_5: '响应于根据权利要求或拒付',
    map_deal_6: 'IPN（即时付款通知）历史',
    map_profile: '我的个人资料和设置',
    map_profile_1: '商业镜',
    map_profile_2: '电子邮件，地址，电话或密码更新',
    map_profile_3: '银行账户或卡更新',
    map_profile_4: '更新通知',
    map_profile_5: '查看账户限额',
    map_profile_6: '用户管理',
    map_profile_7: '送更新偏好',
    map_support: '支持',
    map_support_1: '转至解决冲突中心',
    map_support_2: '去支持中心',
    map_support_3: '联系我们',
    map_support_4: 'ONEWORLDPAY商户费用信息',
    map_report: '报告',
    map_report_1: '报告设置，管理或下载',
    map_manage: '工具',
    map_manage_1: '查看工具',
    map_manage_2: 'ONEWORLDPAY按钮管理',
    map_manage_3: '定期支付管理',
    map_consum: '顾客',
    map_consum_1: '查看嘉宾名单',
  },
  fee: {
    fee_tip: '简单的收费结构',
    fee_banner_1: '一般来说，购买是免费的，可能受到货币兑换费。',
    fee_banner_2:
      '如果销售不坚持使用ONEWORLDPAY月租费，或者取消费用。每个委托后才会支付。',
    fee_h2: '通常购买的是免费的。',
    fee_text1: '用于处理支付费用是由卖方支付。',
    fee_text2: '但是，您可以兑换手续费应用。',
    fee_more: '卖家收费了解更多',
    fee_text3: '对于凭发票或付款电子邮件网站销售（国际支付标准费率适用）',
    fee_text4: '根据收到呼叫的固定费用',
    fee_text5: '交易所费用可以另外申请。',
    fee_text6: '例如，对于一个固定费用付款收据以美元为$ 0.30美元。',
  },
  dash: {
    more: '查看更多',
    withdraw_asset: '基金撤离',
    currency: '货币',
    quotes: '发票和会计估计',
    last_6_months: '最近6个月',
    make_invoice: '发票代',
    manage_invoice: '发票管理',
    grown_up: '请把发展业务的报价。',
    un_paid_invocie: '未付发票',
    make_quotes: '报价代',
    quotes_1: '人提出任何未付发票。',
    quotes_2: 'ONEWORLDPAY发票',
    quotes_alarm: '发送提醒',
    quotes_detail: '显示更多',
    quotes_who: '比尔：财，所以 - 杨',
    latest_act: '近期活动',
    act: '活动',
    received: '收到付款',
    send: '从付款方式',
    act_record: '活动（包括资产和费用）',
    pay_person: '比勒人',
    show_all: '查看所有',
    tell_us: '请告诉我们你的意见。',
    feed_text:
      '请花一点时间来告诉我们在这个页面上全新设计的显示信息，你的意见。谢谢！',
    service: '提供反馈',
    feed_text_back: '谢谢您的意见！这是我们的网站是如何有用吗？',
    feed_placeholder:
      '请让我知道我今天来有ONEWORLDPAY是一个更好的办法的原因。不包括个人信息，如电子邮件或账户号码。',
    feed_p:
      'ONEWORLDPAY办公室工作人员和客人您的意见可以在内部发布，所以你可以看到它，不会留下任何个人信息。客户服务问题，请点击此处。 ONEWORLDPAY的',
    feed_protect: '隐私政策',
    feed_law: '法律条款',
    feed_or: '和',
    feed_need: '见',
    trade_name: '交易名称',
    trade_id: '交易ID',
    transaction_type: '交易类型',
    trade_amount: '付款',
    detail_show: '看',
  },
  shop_detail: {
    detail_info: '店详细',
    api_signature: '商店签名密钥',
    msg_shop_create: '这家商店已被注册。',
    msg_shop_modify: '这家商店已定。',
  },
  merchant_account: {
    create_account: '生成结算账户',
    enroll_account: '登记结算帐户',
    pls_select_account: '选择结算账户',
  },
  transaction_detail: {
    select_pay_account: '请选择支付账户',
    transaction_title: '交易细节',
    order_id: '车间定单号',
    pay_account_title: '付款账户名称',
    pay_account_number: '支付账号',
    pay_account_balance: '付款账户余额',
  },
  guide: {
    title: 'C2C 交易指南',
    watch_video: '查看图片',
  },
  account_transfer: {
    transfer: '转账',
    transfer_list: '转账记录',
    msg_required_data: '请输入所有的值',
    msg_not_select_withdraw_account: '请选择取款账号',
    create_transfer_title: '转账',
    from_account_select: '请选择取款账号',
    available_transfer: '可转账金额',
    to_account_input: '请输入转账账号',
    to_account_confirm: '转账账户确认',
    to_account_user_name: '转账账户会员名',
    transfer_amount: '转账金额',
    delete_amount: '更正',
    all_amount: '全额',
    description: '说明',
    transfer_btn: '转账',
    transfer_btn_2: '转账',
    transfer_info_check: '支票转账请求信息',
    transfer_info_check_2: '支票转账请求信息',
    from_account_number: '取款账号',
    from_asset_title: '取款账户资产',
    to_account_number: '转账账号',
    success_transfer: '转让已成功处理。',
    success_withdraw: '提款已成功处理。',
    transfer_list_detail: '转账记录＆',
    search_transfer_asset: '通过房产搜索',
    search_transfer_account: '请按账户搜索',
    reset: '初始化',
    search: '取回',
    transfer_list_detail_tit: '详细转账记录',
    no_transfer: '不得转让细节',
    msg_not_search_account: '帐号不存在或无效的输入。',
    my_account_transfer: '我的账户转账',
    msg_pls_select_account: '选择资产后，搜索帐户。',
    placeholder_amount: '请输入转账金额',
    not_search_user_name: '不知道用户名',
    msg_select_asset_search: '请选择一个帐号',
    success_fail: '传送失败。',
    pls_search_asset: '请搜索资产',
    pls_search_account: '请搜索账户',
    pls_select_asset: '请选择一种资产。',
    select_account_first: '请先选择一个帐户。',
    select_market_first: '请先选择市场',
    not_exist_account: '资产的帐户不存在。',
    favorites: '收藏夹',
    no_inquiry_history: '没有查询记录',
    from_user_name: '逾期账户的成员',
  },
  bank_service_center: {
    title: '主题',
    date: '日期',
    state: '状态',
    enter_search_word: '输入您的搜索字词',
    list: '名单',
  },
  service_center: {
    view_all: '查看全部',
    contact_history: '查询历史',
    privacy_Statement: '个人信息处理政策',
    would_you_agree: '您要同意以上内容吗？',
    mobile_number: '手机号码',
    target_of_inquiry: '询问对象',
    inquiry_contents: '咨询内容',
    please_enter_your_inquiry: '请输入您的询问。',
    send: '发送',
    normal_inquiries_received: '您的询问已成功收到。',
    inquiry_history: '查询历史',
    pls_select_inquiry_type: '请选择接触的类型',
    pls_login_to_use_inquiry: '1，登录第一查询。',
    non_member_login: '非会员登录',
    contact_id: '联系ID',
    view_inquiry: '查看联系人',
    service_center: '客户服务',
    inquiry_details: '联系方式',
    msg_enter_title: '请输入标题。',
    msg_enter_your_content: '请输入您的信息。',
    msg_pls_login: '请登录。',
    go_back: '回去',
    re_contact: '触点材料',
    contents: '内容',
    msg_no_inquiry_history: '没有联系方式。',
    msg_require_login_additional_authentication: '您需要登录或其他身份验证。',
    when_you_member: '当一个成员',
    msg_inquiry_history_can_view_after_login:
      '的联系人详细信息的成员可以在登录后进行查看。',
    non_member: '当非会员',
    lookup_inquiry: '联系人查找',
    msg_enter_inquiry_id: '请输入联系人ID。',
    msg_enter_password_when_registering_your_inquiry:
      '当你调用注册请输入你设置的密码。',
    frequently_asked_questions: '常问问题',
    msg_enter_your_password: '请输入您的密码。',
  },
  modal: {
    not_seeing_day: '白天没见',
  },
  login_guide_modal: {
    title: '资讯中心',
    sub_title: '会员登录系统将被改造，以便会员能够顺利使用交易所。',
    content:
      '[变更前] <br/> 首次注册时创建的ID登录名 <br/><br/>[变更后] <br/> 更改为您的电话号码或电子邮件登录 <br/><br/> 要在重组登录系统之前登录，只需使用首次注册时创建的ID进行登录。',
  },
  affiliate: {
    affiliate_occur_list: '津贴记录',
    affiliate_adjust_list: '津贴结算明细',
    allowance_balance_asset: '资产备抵余额',
    list_allowance_balance_asset: '按资产划分的备抵余额清单',
    search_by_asset: '请按资产搜索',
    allowance_search: '配额搜索',
    generator: '发电机',
    beneficiary: '受益人',
    benefactor: '恩人',
    behavior_type: '行为类型',
    target_unique_number: '目标唯一编号',
    date_of_occurrence: '发生日期',
    application_policy_name: '申请政策名称',
    beneficiary_type: '受益人 类型',
    benefactor_type: '恩人 类型',
    target_amount: '目标金额',
    principal_amount: '本金',
    allowance: '额外工资',
    allowance_assets: '备抵资产',
    allowance_amount: '津贴额',
    affiliate_log: '津贴细目',
    allowance_settlement: '津贴结算',
    allowance_settlement_info: '津贴结算信息',
    name_asset_settled: '待结算资产名称',
    balance_receive_payment: '待付余额',
    select_account_settled: '选择要结算的帐户',
    no_affiliate_log: '没有津贴。',
    no_affiliate_balance: '没有按资产分类的备抵余额清单。',
    no_affiliate_adjust: '没有津贴支付历史。',
    asset_name: '资产名称',
    asset_code: '资产代码',
    balance: '平衡',
    cumulative_amount: '累计量',
    please_select_account: '请选择一个帐号',
    calculate: '计算',
    settle: '解决',
    calculate_amount: '结算金额',
    account_number: '账号',
    registration_date: '登记日期',
    number: '数',
  },
  Coin_name: '币种',
  main_function: '主功能',
  disclosure_ing: '在...的过程中',
  market_balance_transfer: '市场余额移动',
  available_after_login: '登录后即可使用。',
  fast_stable_deal: '一起快速稳定的交易',
  cryptocurrency_exchange: '加密货币交易所',
  go_transaction: '马上交易',
  create_an_account: '创建帐户',
  more_than_that: '那以上的价值',
  vision_title: '基于信任的规划',
  vision_text1: 'ONEWORLDPAY在新的数字资产生态系统中提供将区块链技术',
  vision_text2: '整合到现有支付网络的一站式解决方案。',
  fee_title: '手续费优惠',
  fee_text1: '免除创建账户手续费和账户维护费用',
  fee_text2: '免除购买/出售手续费。',
  row_title: '低门槛',
  row_text1: '比特币、以太坊等多种虚拟货币，',
  row_text2: '低门槛，可以千元交易',
  easy_title: '便利的界面',
  easy_text1: '初学者也可以轻松交易。',
  easy_text2: '',
  full_time: 'Full Time交易',
  full_time_text1: '无论何时何地只要有手机和电脑，',
  full_time_text2: '一年365天24小时都可以交易。',
  easy_sellbuy: '随时随地的便捷交易',
  so_easy: '轻松舒适',
  b2c_mobile: 'B2C移动应用',
  app_sellbuy: '通过应用程序移动设备交易的话，',
  anywhere_use: '无论何时何地都可以和B2C一起进行交易。',
  now_start_buy: '马上交易',

  procedure:
    '在ONEWORLDPAY.COM/COCOBNK.COM登陆时，对进行信息共享的批准过程，是SNS登录（社交登录）的必要步骤。如果未执行SNS的登录过程，则无法登录到ONEWORLDPAY / COCOBNK，该过程是根据《信息通信网络法》和《个人信息保护法》执行的。',
  snslink: '关于SNS帐户关联状态下登录的信息通信网络法是',
  four_one:
    '第四条①科学技术通信部长官 <br> 通广播通信委员会通过促进信息通信网络的使用及稳定的管理和用户保护等（以下称“信息通信网络的促进以及信息保护等”），为建立信息社会奠定制定措施。',
  four_two: '②第1款规定的政策包括以下内容。  ',
  eight: '8 信息通信网络的安全性和可靠性',
  nine: '9.此外，促进信息通信网络的使用以及信息保护等需要的事项',
  execution: '正在按照该条款执行',
  privacy: '另外，个人信息保护法',
  twentyfour_three:
    '第二十四条（限制固有识别信息处理）③当个人信息控制者按照第一款的每个分段处理固有识别信息时，根据总统令规定其固有识别信息不会丢失、盗取、泄露、伪造、变造、损坏，因此要采取加密等确保安全性必要措施。',
  twentyfour_two:
    '第24-2条 (限制居民身份证号码处理）②个人信息管理者尽管有第24条第3款,也必须通过加密措施来确保其居民身份证号码不被丢失，被盗，泄漏，伪造，更改或损坏的安全。在这种情况下，有关加密适用对象和各适用对象时期的必要事项是根据总统令考虑个人信息的处理规<br>模和泄漏的影响来决定。',
  implemented: '正在按照该条款执行.',
  we_future: '我们的未来',
  pop_cocobank: '可可银行',
  fourth_industry: '第四产业的领导者',
  oc_15: '十月15',
  officially_open: '正式开放！',
  head_branch_office: '韩国总公司（蚕室店）/第一分店（新沙店）',
  sep_15: '9月15日下午5点',
  open_popup: '打开',
  thanks_for: '谢谢您的鼓励。',

  kiosk: {
    make_pay: '结算',
    product_name: '商品名',
    amount_payment: '结算金额',
    may_pay_guide_txt:
      '请将 <span style="font-weight:900; color:#2369b0;">ONEWORLDPAY {os}的结算二维码</span> 扫描到终端即可完成结算。',
    app_download_btn: '请安装 ONEWORLDPAY {os}',
    app_download_qr_scan: '请扫描二维码下载app。',
    app_install_txt:
      '请扫描下面的二维码安装 <span style="font-weight: 900; color: #1f67af">ONEWORLDPAY {os}。</span>',
    app_install_sub_txt:
      '请将ONEWORLDPAY 结算页面二维码扫描到终端即可进行结算。',
    app_install_sub_txt2: '会在以后提供ONEWORLDPAY ios服务。',
    direct_exchange_txt:
      '<span>将</span><strong>{asset1}</strong><strong>兑换</strong><span>成</span><strong>{asset2}</strong>',
    bank_use: '使用BANK',
    cocobank: 'ONEWORLDPAY',
    cocobank_account_transfer: '转账',
    store_use: '命令',
    location_store: 'co.u co.u',
    home_ad_1: '世界上第一个硬币公开市场',
    home_ad_2: 'COCO MARKET',
    use: '使用方法',
    bank_direct_ex: '我马上换钱',
    deposit_inquiry: '查询',
    deposit_inquiry_txt: '查询ONEWORLDPAY 账户',
    deposit_withdrawal: '取款',
    deposit_withdrawal_txt: '申请后，需要10秒~10分钟左右',
    deposit_transfer: '转账',
    deposit_transfer_txt: 'ONEWORLDPAY 账户转账',
    wallet_transfer: '钱包转账',
    wallet_transfer_txt: '其他交易所钱包转账',
    exchange_list: '兑换记录',
    certified: '认证管理',
    certified_drawer_title: '认证管理',
    direct_transaction: '直接交易',
    direct_transaction_txt: '立即兑换',
    c2c_transaction: 'C2C交易',
    c2c_transaction_txt: '客户之间进行加密货币交易',
    account_application: '申请账户',
    account_application_txt: '申请账户',
    terms_title1: '有关限制限额的信息，以防止损害电信财务欺诈',
    terms_text1:
      '由于非面对面的帐户开设，通过自动设备和互联网进行的提款（转账）限制为每天0 CCF。<br />可以向分支机构提供用于确认交易目的的客观身份验证数据，并且可以在“管理>安全身份验证/管理”中取消限制。<br />使用网上银行时，必须注册一个提款帐户才能进行转账交易。<br />每个加密货币限制只能开设5个帐户。',
    terms_notice1: '注意',
    terms_notice1_txt:
      '- 注册网上银行可以在开立存取款账户后，在完成画面上联动申请。<br />- 现有的网上银行注册客户，请注意，只有在取款账户登陆区分为互联网+分行时，才能通过网上银行登录取款账户。',
    terms_notice2:
      '※ 先进行安全认证的话，需要建立账户，使用网上银行时登录到取款账户才能进行转账交易。',
    cancel: '取消',
    security_authentication: '安全认证',
    new_registration: '注册',
    terms_title2:
      '点击注册后，将发放会员固有的ONEWORLDPAY {0}专用账户及外部钱包联动汇款地址。',
    terms_notice3: '汇款前一定要确认！',
    terms_notice3_text1:
      '只有注册时发行的账户/地址才能进行{0}汇款。如果试图将其他数字资产存入该地址，可能发生的错误/损失将无法恢复。',
    terms_notice3_text2:
      '确认后，通过汇款流程反映到余额中。汇款过程将自动进行，根据网络情况所需时间可能会有所不同。',
    terms_notice3_text3: '上述地址是汇款专用地址。',
    terms_checkbox_text: '您是否同意并理解以上内容？',
    assets: '资产',
    favorite: '收藏夹',
    select_assets_txt: '请选择一种资产。',
    search_assets: '搜索资产',
    search_assets_txt: '请搜索资产。',
    account_name: '用户名',
    account_name_txt: '请输入您的帐号',
    selected_assets: '可选资产',
    account_unique_number: '帐户唯一编号',
    account_number: '账号',
    stop_amount: '止损金额',
    state: '州',
    auto_input: '自动输入',
    opening: '开了',
    application_success_txt: '帐户申请已完成。',
    application_fail_text: '帐户申请失败。',
    confirm: '确认',
    previous: '以前',
    enter_account_number: '请输入账号',
    service_preparation: '服务准备中',
    service_preparation_txt1: '为了提供更好的服务，页面正在准备中。',
    service_preparation_txt2: '会尽快安排时间拜访您。',
    search_account: '搜索账户',
    search_account_txt: '请搜索账户',
    select_account_txt: '请选择账户。',
    withdrawable_amount: '可取金额',
    inquiry_period: '查询时间',
    variable_amount: '变动金额',
    no_deposit_history: '没有查询存款记录',
    select_date: '请选择日期',
    type_of_change: '变动类型',
    sort_order: '排序顺序',
    inquiry_option: '查询选项',
    select_market: '请选择市场',
    reduction_rate: '手续费率',
    sales_quantity: '销售数量',
    minimum_purchase_quantity: '最少购买数量',
    selling_price_per_piece: '单个销售价格',
    account_for_registration_of_sales: '销售登记用账户',
    purchase_assets: '购买资产',
    available_quantity: '可用数量',
    purchase_quantity: '购买数量',
    price_per_piece: '单价',
    quantity_to_be_paid: '要支付的数量',
    select_account_to_receive: '选择要收款的账户',
    registration_was_successful: '登录成功',
    registration_failed: '登录失败。',
    go_to_first: '回到首页',
    purchase_history: '购买明细',
    purchase_price: '购买价格',
    no_description: '没有明细。',
    sales_history: '销售明细',
    price_per_quantity: '按数量计价',
    total_fee: '手续费合计',
    no_disclosure_details: '没有公示内容',
    advanced_search: '详细搜索',
    sales_registration: '出售登记',
    purchase_registration: '购买登记',
    verification_completed: '认证完了',
    email_authentication: '电子邮件认证',
    authenticate: '认证',
    identity_verification: '本人认证',
    otp_authentication: 'OTP认证',
    withdrawal_address_verification: '取款地址验证',
    withdrawal_address_application_details: '取款地址申请记录',
    no_withdrawal_address_application_details: '没有取款地址申请记录',
    kyc_authentication: 'KYC 认证',
    kyc_application_details: 'KYC 认证记录',
    security_level: '安全等级',
    view_rating: '查看等级',
    no_account_alias: '（没有账户名称）',
    no_choice: '（没有选择）',
    select_coin_to_exchange: '请选择想要兑换的硬币',
    sending_verification_email: '发送认证邮件',
    sending_verification_email_txt: '请点击发送认证邮件。',
    enter_verification_code: '认证',
    enter_verification_code_txt: '请输入验证码',
    verification_email_has_been_sent: '已发送认证邮件',
    base_asset_account_information: '基准资产账户信息',
    classification_of_transactions: '交易区分',
    logged_out_txt: '注销了',
    check_logged_out_txt: '你要登出吗',
    scan_qr_code_txt: '请扫描下面的二维码',
    simple_login: '简单登录',
    simple_login_txt: '请输入简单登录验证码',
    be_loggin_in: '登录中',
    be_logged_in: '登录了',
    step_one: '一阶段',
    step_one_txt: '为了认证OTP，请在App Store安装Google OTP。',
    step_two: '二阶段',
    step_two_txt:
      '请打印或记录已发行的16位代码。本代码用于修复手机上的丢失/更换及删除。',
    step_three: '三阶段',
    step_three_txt: '通过安装的Google Authenticaror应用程序扫描下面的二维码。',
    step_four: '四阶段',
    step_four_txt: '输入生成的OTP 6位数字验证码后点击认证。',
    mobile_authentication: '手机认证',
    mobile_authentication_txt: '利用本人名义的手机进行认证',
    do_mobile_authentication: '手机认证',
    complete_mobile_authentication: '认证完成了',
    failed_mobile_authentication: '认证失败了',
    transfer_quantity: '转账数量',
    enter_transfer_quantity: '请输入转账数量。',
    transfer_quantity_2: '转账数量',
    enter_transfer_quantity_2: '请输入转账数量。',
    select_transfer_quantity: '请选择转账数量。',
    enter_transfer_account_number: '请输入转账账号',
    current_security_level: '会员现在的安全等级',
    choose_how_to_pay_the_fee: '请选择手续费支付方法',
    confirm_withdrawal_application_information: '确认取款申请信息',
    enter_login_code_txt:
      '请阅读下面条形码阅读器中终端屏幕上显示的用于简单登录验证的QR码，或在下面的字段中输入简单验证码。',
    direct_ex_manual: '如何使用直接货币兑换',
    deposit_transfer_manual: '如何使用存款汇款',
    deposit_inquiry_txt_manual: '如何使用存款查询',
    deposit_withdrawal_manual: '如何使用存款提取',
    wallet_transfer_manual: '如何使用钱包传输',
    buy_with_coin_selected_account: '使用{code}从选定的帐户购买',
    sell_with_coin_selected_account: '在所选帐户上出售{code}。',
    receive_purchased_coin: '请选择一个帐户以接收购买的{code}。',
    receive_converted_coin: '请选择一个帐户以接收转换后的{code}。',
    enter_account_holder: '请输入帐户持有人的姓名。',
    enter_account: '请输入您的帐号。',
    enter_withdrawal: '请输入提款金额。',
    transfer_to_another_wallet: '转移到另一个钱包',
    invalid_login_code: '无效的登录身份验证代码。',
    payment_canceled: '付款已被取消',
  },

  market_balance: {
    deposit_successful: '存款成功。',
    wthdrawal_successful: '提款成功。',
    deposit: '存放',
    withdrawal: '取出',
    select_account: '选择帐号',
    assets: '资产',
    select_market: '市场选择',
    quantity: '数量',
    confirm: '确认',
  },
  pop_notice: {
    notice_close: '關閉',
    notice_today: '今天不看',
  },
  private_notice: {
    msg_false_deal_title: '禁止虚假公示',
    msg_false_deal_content_1:
      '卖家必须充分持有要卖出的加密货币，然后进行交易。',
    msg_false_deal_content_2: '持续进行虚假公示时，服务会受到限制。',
    msg_deal_confirm_click_title: '点击确定时的注意事项',
    msg_deal_confirm_click_content_1: '卖家必须在确认买家付款后点击“确定”，',
    msg_deal_confirm_click_content_2:
      '对于卖家不小心造成的金钱损失，ONEWORLDPAY不会负法律责任。请务必确认买家是否付款。',
    msg_deal_confirm_not_click_title: '当没有按下确认键',
    msg_deal_confirm_not_click_content_1:
      '卖家在确认买家支付与否后，点击“确定”。',
    msg_deal_confirm_not_click_content_2:
      '如果没有点击“确定”，管理员会限制服务使用。',
    msg_c2c_title: 'C2C交易',
    msg_c2c_content_1: 'C2C交易是由卖家和买家的自由交易活动为基础的。',
    msg_c2c_content_2: 'ONEWORLDPAY只提供卖家和买家方便安全交易的平台服务。',
    msg_c2c_content_3:
      '请注意，卖家和买家之间发生法律纠纷时ONEWORLDPAY只负责作为信托账户的责任。',
    msg_false_hold_title: '禁止持假',
    msg_false_hold_content_1: '买家必须在该C2C交易支付完毕后点击“holding”。',
    msg_false_hold_content_2:
      '因虚假holding而发生的卖家和买家之间的纷争不由ONEWORLDPAY负责。',
    msg_false_hold_content_3:
      '另外，持续进行虚假holding时，请注意服务使用将受到限制。',
    msg_false_hold_content_4:
      '支付完毕后无法确定时，请通过1对1咨询跟管理员沟通。',
    msg_false_hold_content_5:
      '通过外部钱包进行C2C交易时，会收取手续费，如果C2C交易无法正常进行时，对该交易的解决可能会有不便。',
  },
  kiosk_re: {
    choice_lang: '언어선택',
    buy_immedi:
      'ONEWOLRDPAY를 이용하시면<br><span>즉시 구입</span>이 가능합니다.',
    new_acc: 'ONEWOLRDPAY 계좌만들기',
    join_txt:
      '외부지갑 및 계좌를 이용시에는 구매예약을 하여 판매자의 확인여부가 필요하나 ONEWOLRDPAY를 이용하시면 즉시 구입이 가능 하십니다. ONEWOLRDPAY내에 이동시 수수료를 받지 않으며 세상에서 가장 빠른 암호자산간 이동을 지원하고 있습니다.',
    main_order_txt: '신용카드/암호자산 매장내 구입',
    main_bank_txt: '암호자산 안전하게 보관 및 구입/판매',
    main_market_txt: '온라인 암호자산 오픈마켓',
    main_about: '어바웃코인',
    main_about_txt: '암호자산에 대한 전문뉴스',
    about_drw_txt_1:
      '빠르고 다양한 블록체인 소식을<br><span>coinabout</span>에서 받아보세요.',
    about_drw_txt_2:
      '코인어바웃은 블록체인과 핀테크에<br>대한 빠른 소식과 분석을 제공합니다.',
    about_drw_txt_3: 'QR 코드를 스캔하면 코인어바웃으로 연결됩니다.',
    market_drw_txt_1: '이제 <span>가상자산으로 쇼핑</span>하세요.',
    market_drw_txt_2:
      '저희 코코마켓은 국내 최초 가상자산으로<br>물건을 사고팔 수 있는 오픈마켓입니다.',
    market_drw_txt_3: 'QR 코드를 스캔하면 코코마켓으로 연결됩니다.',
    market_drw_txt_4:
      '코코마켓은 이후 많은 상품과  다양한 가상자산<br>결제 시스템을 구축할 예정입니다.',
    login_title: '아래 <span>QR 코드</span>를 스캔해주세요.',
    login_txt_1: '서비스 사용을 위한 사용자의 정보가 필요합니다.',
    login_txt_2:
      '단말 화면에 표시된 간편 로그인 인증 코드를 아래 입력란에 입력해주세요.',
    code_txt: '간단로그인<br> <span>인증코드</span>를 입력하세요.',
    new_acc_tit_1: '신규 계좌 생성',
    new_acc_tit_2: '신규 계좌 생성에 필요한 내용들을 확인해 주세요.',
    new_acc_txt_1: '전기통신 금융사기 피해예방을 위한 한도제한 안내',
    new_acc_txt_2:
      '* 인터넷뱅킹으로 이체거래를 보다 더 간편하게 진행하시려면 보안 인증을 거치셔야합니다. 인증 과정을 통하여 등급을 향상시킨 후 계좌생성 및 출금계좌등록을 진행하시기 바랍니다.',
    new_acc_txt_3:
      'ONEWOLRDPAY전용 계좌에서 계좌로 송금하면 수수료가 일체 없습니다. 신규가입시 발행되는 계좌/주소로는 {0} 만 입금 가능합니다. 해당 주소로 다른 디지털 자산을 입금 시도할 경우에 발생할 수 있는 오류/손실은 복구 불가능 합니다. 1번의 확인이 발생한 이후, 입금 프로세스를 거쳐 잔고에 반영됩니다. 입금 프로세스는 자동으로 진행되며 네트워크 상황에 따라 소요 시간이 달라 질 수 있습니다. 위 주소는 입금전용 주소입니다.',
    new_acc_txt_4:
      '회원님에게 할당된 신규가입으로는 {0} 을 입금할 수 있습니다.',
    new_acc_btn_agr: '동의 및 계좌 개설',
    new_acc_txt_5: '신규 계좌가 개설되었습니다.',
    new_acc_txt_6: '개설된 계좌로 ONEWOLRDPAY서비스를 이용가능합니다.',
    charge_tit_1: '{0}를 충전합니다.',
    charge_tit_2: '{0}충전에 사용될 자산을 선택해주세요.',
    charge_tit_3: '계좌 선택 및 충전에 사용될 자산 수량을 입력해 주세요.',
    charge_txt_1: '충전 기준율',
    charge_txt_2: '충전 유형',
    charge_txt_3: '기준 수량',
    charge_txt_4: '충전 총액',
    charge_txt_5: '충전하기',
    charge_txt_6: '충전이 완료되었습니다.',
    charge_txt_7: '3초 뒤에 메인화면으로 돌아갑니다.',
    complete: '선택완료',
    input_complete: '입력완료',
    quan_max: '최대',
    buy_reserv: '구매예약 체결',
    krw_dialog_tit: '입금후에 구매예약 체결 버튼을 클릭해 주세요.',
    krw_dialog_txt_1:
      '이전 구매예약 클릭시 지갑 및 계좌는 동결되며 구매자가 최종적으로 아래 지갑 및 계좌에 최종 지불 할 금액을 입금후에 구매예약 체결 버튼을 클릭하셔야만 판매자에게 알림이 가며 판매자가 구매확인 하는 순간 구입자의 지갑 및 계좌에 구매하신 자산이 입금 됩니다.',
    krw_dialog_txt_2:
      '* 입금이 3시간 안에 구매예약 체결이 되지 않으면 동결된 지갑 및 계좌가 사용가능 하게 됩니다. 단, 입금하고 1시간 에서 2시간 안에 입금이 되지 않으면 고객센터에 연락주시기 바랍니다.',
    krw_dialog_txt_3:
      '구매자는 예약만 하고 입금이 3회 이상 되지 않으면 아이디가 정지됩니다.',
  },
}
